<template>
  <div class="flex h-full mt-20">
        <div class="flex max-w-3xl mx-auto content-center flex-wrap">
            <!-- Main SubTitle  -->
            <div class="w-full flex mb-2 ml-2">
                <BackButton class="" />
            </div>
            <div class="flex flex-grow p-2">
              <div>
                  <div class="bg-herored h-full p-1 m-2"></div>
              </div>
              <div class="lg:w-8/12 lg:self-center ">
                  <span class="lg:text-4xl font-semibold text-2xl pr-6 block">Everyone is a Move Hero. Question is, which one are you?</span>
              </div>
            </div>
            <!-- TextBox -->
            <div class="lg:w-7/12 lg:mt-5 text-left m-4">
                <AboutTextBox
                :text="text"
                />
                <router-link v-if="user.loggedIn" class="leading-loose text-herored underline" :to="{ name: 'Question', params: { level: 'entry', id: 0 } }">{{link}}</router-link>
                <router-link v-else class="leading-loose text-herored underline" :to="{ name: 'MainMenu' }">Sign In to take the quiz yourself?</router-link>

            </div>
            <!-- Dummy Block -->
            <div class="lg:w-1/12"></div>
        </div>
    </div>
</template>

<script>
import BackButton from "@/components/content/buttons/BackButton.vue"
import AboutTextBox from "@/components/content/textbox/AboutTextBox.vue"
import { mapState } from "vuex";

export default {
    components: {
        AboutTextBox,
        BackButton
    },
    data() {
        return {
            text: "Everyone is a Move Hero. Question is, which one are you? We’re all moving to 1 Blackfriargate, but the journey will be different for each of us. That’s because we all have different unconscious motivators. This short quiz will help you uncover which Move Hero you are, so you’ve got a better understanding of the role you can play in making our move a success for everyone. It uses the PRINT® model to explore the unconscious motivations that drive a person’s behaviour and actions. So, what are you waiting for? Take the quiz today and discover your Move Hero – then check in with your colleagues to find out theirs and see how you can support each other. ",
            link: "Why not take the quiz yourself?",
        }
    },
    computed: {
      ...mapState({
        user: "user"
      })
    },
}
</script>

<style>

</style>
